__turbopack_context__.v({
  "button": "index-module-scss-module__x0oTGa__button",
  "continueButtonShake": "index-module-scss-module__x0oTGa__continueButtonShake",
  "shake": "index-module-scss-module__x0oTGa__shake",
  "special": "index-module-scss-module__x0oTGa__special",
});
